import React, { Component } from "react";
import { Buffer } from "buffer";
import process from "process";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import "./css/style.css";
import "./css/purpleresponsive.css";
import "./css/admin.css";
import "./css/adminresponsive.css";
import home from "../src/home/home";
import root from "../src/layout/root";
import AboutUs from "./home/aboutus";
import Contact from "./home/contactus";
import Telehealth from "./home/telehealth";
import BrandedAppsWebsite from "./home/branded-apps-website";
import ClinicManagement from "./home/clinic-management";
import Clients from "../src/home/clients";
import DoctorDetail from "./home/doctor-detail";
import DoctorListMain from "./home/doctor-list-main";
import OnlineDoctors from "./home/online-doctors";
import OnlineDoctorsSub from "./home/online-doctors-sub";
import email from "./patient/email";
import EmailConfirm from "./patient/emailconfirm";
import EmailSuccess from "./patient/emailsuccess";
import Textchat from "./patient/textchat";
import TextchatSuccess from "./patient/textchatsuccess";
import Bookappointment from "./patient/bookappointment";
import BookappointmentSuccess from "./patient/bookappointmentsuccess";
import Chatmessage from "./patient/chatmessage";
import VideocallList from "./patient/videocalllist";
import ChatmessageGroup from "./patient/chatmessagegroup";
import Videocall from "./patient/videocall";
import VideochatSuccess from "./patient/videochatsuccess";
import Appointmentlist from "./patient/appointmentlist";
import Inbox from "./patient/inbox";
import Send from "./patient/send";
import Messgedetail from "./patient/messgedetail";
import Profile from "./patient/profile";
import ProfileEdit from "./patient/profile-edit";
import Dashboard from "./doctor/dashboard";
import Drgallery from "./doctor/drGallery";
import ChangePassword from "./doctor/changepassword";
import WorkTime from "./doctor/worktime";
import Doctorprofile from "./doctor/doctorprofile";
import Docservices from "./doctor/docservices";
import VideoSchedule from "./doctor/videoSchedule";
import Healtharticle from "./doctor/healtharticle";
import Healthblog from "./doctor/healthblog";
import HealthRecord from "./patient/health-record";
import HealthTrackers from "./healthTrackerCalender/health-trackers";
import HealthTrackbabymilestns from "./healthTrackerCalender/health-trackers-babymilestone";
import HealthTrackbabymilestnsdwd from "./healthTrackerCalender/health-trackers-babymilestone-download";
import HealthTrackbabymilestnsdwdpdf from "./healthTrackerCalender/health-trackers-babymilestone-download-pdf";
import HealthTrackimmunisation from "./healthTrackerCalender/health-trackers-immunisation";
import HealthTrackimmunisationdwd from "./healthTrackerCalender/health-trackers-immunisation-download";
import HealthTrackimmunisationdwdpdf from "./healthTrackerCalender/health-trackers-immunisation-download-pdf";
import HealthTrackimmunisationreminders from "./healthTrackerCalender/health-trackers-immunisation-reminders";

import HealthRecordLogin from "./patient/healthrecordlogin";
import History from "./patient/history";
import DoctorVideocall from "./doctor/videocall";
import DoctorInbox from "./doctor/doctorinbox";
import DoctorSend from "./doctor/doctorsend";
import DoctorMessgedetail from "./doctor/messgedetail";
import DoctorChatmessage from "./doctor/chatmessage";
import DoctorChatmessageGroup from "./doctor/chatmessagegroup";
import DoctorChatHistory from "./doctor/chat-history";
import OldChatMessage from "./patient/archivedMessageChats";
import SamadHome from "./SAMADIVF/home";
import PrescriptionList from "./patient/prescription-list";
import PrescriptionAdd from "./doctor/prescription-add";
import Common from "./home/common";
import HeaderLinks from "./dashboard/headerLinks";
import CommonMenuLinks from "./home/commonMenuLinks";
import PaymentSuccess from "./patient/paymentSuccess";
import AdminDashboard from "./adminDashboard/dashboard";
import Analysis from "./dashboard/analysis";
import ThemeEdit from "./home/themeEdit";
import TermsConditions from "./home/terms-conditions";
import PrivacyPolicy from "./home/privacy-policy";
import DrTermsConditions from "./doctor/terms-conditions";
import InpersonAppointment from "./doctor/inpersonAppointment";
import DoctorPrescription from "./doctor/prescriptionList";
import MapLink from "./Ganga/map";
import TestHouse from "./patient/testHouse";
import BlogList from "./doctor/blog";
import BlogDetails from "./Sabarmathi/blogDetails";
import SiteBlog from "./Sabarmathi/healthBlog";
import Favorate from "./patient/favorate";
/*** pharmacy app screens***/
import Splash from "./pharmacyApp/splash";
import DoctorNetwork from "./pharmacyApp/doctor-network";
import DoctorInvitation from "./pharmacyApp/doctor-invitation";

/*** Doctor Registration***/
import DoctorRegistration from "./doctor/registration";
import doctorRegSuccess from "./doctor/doctorRegSuccess";
import timeComponent from "./doctor/timeComponent";
import registrationErrorPage from "./doctor/registrationErrorPage";
import videoRecordList from "./doctor/videoRecordList";
import reportDoctor from "./doctor/reportDoctor";
import hospitalReports from "./dashboard/hospitalReports";
import privillageReport from "./dashboard/privillageCardDetailsReport";
import Maintenance from "./home/maintenance";
import reportDashboard from "./dashboard/reportDashboard";
import videoaudioReports from "./dashboard/videoaudioReports";
import textChatReports from "./dashboard/textChatReports";
import inPersonReports from "./dashboard/inPersonReports";
import ThemeColor from "./adminDashboard/themeColor";
import NewFeeds from "./doctor/newFeedsList";
import NewFeedsListDetails from "./doctor/newFeedsListDetails";
import OpenAppointmentlist from "./patient/openAppointmentList";
import JournalListing from "./doctor/journalListing";
import DoctorRegistrationReport from "./dashboard/doctorRegistrationReport";
import IDABannerSave from "./dashboard/BannerIDASave";
import BannerIDAListing from "./dashboard/BannerIDAListing";
import PharmaNetworkReport from "./dashboard/pharmaNetworkReport";
import DoctorNetworkReport from "./dashboard/doctorNetworkReport";
import AddJournal from "./doctor/addJournal";
import dataMigration from "./adminManagement/dataMigration/dataMigration";
import adApproval from "./adminManagement/pharmaAdAproval/adApproval";
import offerAddPage from "./adminManagement/pharmaAdAproval/offerAddPage";
import addEditofferPage from "./adminManagement/pharmaAdAproval/addEditOfferDetails";
import GenerateQRcodeIda from "./adminManagement/pharmaAdAproval/generateQRcodeIda";
import AddapprovalEdit from "./adminManagement/pharmaAdAproval/adApprovalEdit";
import IdaStoreList from "./adminManagement/pharmaAdAproval/idaStoreList";
import AddEditIdaStore from "./adminManagement/pharmaAdAproval/addEditIdaStore";
import patientTransactionReport from "./dashboard/patientTransactionReport";
import PromocodeDetail from "./hospital/promocodeDetails";

import JoinAsPatient from "./IMAHospitals/joinAsPatient";
import HospitalDetails from "./IMAHospitals/hospitalDetails";
import Grievance from "./IMAHospitals/grievance";
import facilities from "./IMAHospitals/facilities";
import helpLine from "./IMAHospitals/helpLine";
import enroll from "./IMAHospitals/enroll";
import DoctorsList from "./IMAHospitals/doctor-list";

import ImaJoinAsPatient from "./IMAHospitals/joinAsPatient";
import ImaEnroll from "./IMAHospitals/enroll";
import ImaFacilities from "./IMAHospitals/facilities";
import ImaHelpLine from "./IMAHospitals/helpLine";
import Imagrievance from "./IMAHospitals/grievance";
import About from "./IMAHospitals/about-us";

import AnalyticsDashboard from "./analytics/dashboard";
import AnalyticsReport from "./analytics/analyticsReport";
import CategoriesList from "./adminManagement/pharmaAdAproval/categoriesList";
import CategoriesListEdit from "./adminManagement/pharmaAdAproval/categoryListEdit";
import JournalListings from "./adminManagement/pharmaAdAproval/journals";
import JournalListingsAdd from "./adminManagement/pharmaAdAproval/JournalListingsAdd";
import Feedback from "./adminManagement/dataMigration/feedback";
import FAQ from "./home/faq";
import MoreLocations from "./pamba/moreLocations";
import CreatePoll from "./adminManagement/pharmaAdAproval/create-poll";
import PollList from "./adminManagement/pharmaAdAproval/poll-list";
import PollReport from "./adminManagement/pharmaAdAproval/pollReport";
import PollHistory from "./adminManagement/pharmaAdAproval/pollHistory";

/******** IDA ******/
import DoctorListMain1 from "./Sparsh/doctor-list-main1";
import DoctorDetailIDA from "./Sparsh/doctor-detail 1";
import List from "./Sparsh/online-doctors";
import SiteBlogIDA from "./Sparsh/healthBlog";
import BlogDetailsIDA from "./Sparsh/blogDetails";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { authHelper } from "./utilis/authHelper";
import { getSiteData } from "./layout/getSiteDetails";

import loaderImg from "./image/theme/loader.gif";

window.process = process;
window.Buffer = Buffer;

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      authHelper.isLoggedIn() ? <Component {...props} /> : <Redirect to="/" />
    }
  />
);

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      siteReady: !!window.sessionStorage.getItem("siteId"),
      error: false,
    };
  }

  componentDidMount() {
    if (!this.state.siteReady) {
      getSiteData()
        .then(() => {
          this.setState({ siteReady: true });
        })
        .catch((err) => {
          console.error("Failed to load site details:", err);
          this.setState({ error: true });
        });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: "30vh", textAlign: "center" }}>
          <p>Failed to load site. Please refresh the page.</p>
        </div>
      );
    }

    if (!this.state.siteReady) {
      return (
        <div style={{ padding: "30vh", textAlign: "center" }}>
          <img src={loaderImg} alt="Loading..." />
        </div>
      );
    }

    const siteId = window.sessionStorage.getItem("siteId");
    return (
      <Router>
        <Switch>
          {/* Public routes (accessible without authentication) */}
          <Route path="/" component={home} exact />
          <Route exact path="/SITEID-:siteId" component={root} />
          <Route path="/home/aboutus" component={AboutUs} />
          <Route path="/home/contactus" component={Contact} />
          <Route path="/home/telehealth" component={Telehealth} />
          <Route
            path="/home/branded-apps-website"
            component={BrandedAppsWebsite}
          />
          <Route path="/home/clinic-management" component={ClinicManagement} />
          <Route path="/home/clients" component={Clients} />
          <Route path="/home/doctor-detail" component={DoctorDetail} />
          <Route path="/home/online-doctors" component={OnlineDoctors} />
          <Route path="/home/online-doctors-sub" component={OnlineDoctorsSub} />
          <Route path="/patient/email" component={email} />
          <Route path="/patient/emailconfirm" component={EmailConfirm} />
          <Route path="/patient/emailsuccess" component={EmailSuccess} />
          <Route path="/patient/textchatpayment" component={Textchat} />
          <Route path="/patient/textchatsuccess" component={TextchatSuccess} />
          <Route path="/patient/bookappointment" component={Bookappointment} />
          <Route
            path="/patient/bookappointmentsuccess"
            component={BookappointmentSuccess}
          />
          <Route path="/patient/thankyou" component={PaymentSuccess} />
          <Route path="/chat/chatmessage" component={Chatmessage} />
          <Route path="/chat/archivedMessageChats" component={OldChatMessage} />
          <Route path="/patient/videocalllist" component={VideocallList} />
          <Route path="/chat/chatmessagegroup" component={ChatmessageGroup} />
          <Route path="/patient/videocall" component={Videocall} strict />
          <Route
            path="/patient/videochatsuccess"
            component={VideochatSuccess}
          />
          <Route path="/health-trackers" component={HealthTrackers} />
          <Route
            path="/health-trackers-babymilestone"
            component={HealthTrackbabymilestns}
          />
          <Route
            path="/health-trackers-babymilestone-download"
            component={HealthTrackbabymilestnsdwd}
          />
          <Route
            path="/health-trackers-babymilestone-download-pdf"
            component={HealthTrackbabymilestnsdwdpdf}
          />
          <Route
            path="/health-trackers-immunisation"
            component={HealthTrackimmunisation}
          />
          <Route
            path="/health-trackers-immunisation-download"
            component={HealthTrackimmunisationdwd}
          />
          <Route
            path="/health-trackers-immunisation-download-pdf"
            component={HealthTrackimmunisationdwdpdf}
          />
          <Route
            path="/health-trackers-immunisation-reminders"
            component={HealthTrackimmunisationreminders}
          />
          <Route path="/patient/favorate" component={Favorate} />
          <Route
            path="/patient/healthrecordlogin"
            component={HealthRecordLogin}
          />
          <Route path="/samadivf/home" component={SamadHome} />
          <Route path="/1-:pageName" component={Common} exact />
          <Route path="/home/themeEdit/:pageName" component={ThemeEdit} />
          <Route path="/dashboard/HeaderLinks" component={HeaderLinks} />
          <Route path="/2-:pageName" component={CommonMenuLinks} />
          <Route path="/termsConditions" component={TermsConditions} />
          <Route path="/privacyPolicy" component={PrivacyPolicy} exact />
          <Route path="/termsAndConditions" component={DrTermsConditions} />
          <Route path="/footer/map" component={MapLink} />
          <Route path="/testHouse" component={TestHouse} />
          <Route path="/splash/:splashId?/:networkId" component={Splash} />
          <Route path="/doctorNetwork" component={DoctorNetwork} />
          <Route path="/doctorInvitation" component={DoctorInvitation} />
          <Route path="/BlogList" component={BlogList} />

          <Route path="/faq-:id" component={FAQ} />
          <Route path="/maintenance" component={Maintenance} exact />
          <Route
            path="/hospital/promocodeDetails"
            component={PromocodeDetail}
          />
          <Route
            path="/hospitalDetails/:hospitalId?"
            component={HospitalDetails}
          />
          <Route path="/doctorsList" component={DoctorsList} />
          <Route path="/joinAsPatient" component={ImaJoinAsPatient} />
          <Route path="/Enroll" component={ImaEnroll} />
          <Route path="/facilities" component={ImaFacilities} />
          <Route path="/helpLine" component={ImaHelpLine} />
          <Route path="/grievance" component={Imagrievance} />
          <Route path="/aboutUs" component={About} />
          <Route path="/5a6uk96q0w-:token" component={home} />
          <Route path="/5a6uk96sph-:token" component={Feedback} />
          <Route path="/moreLocations" component={MoreLocations} />
          <Route path="/list" component={List} />
          <Route
            path="/doctorRegistration/:pmSite?/:doctorId?/:idaId?"
            component={DoctorRegistration}
            exact
          />
          <Route path="/doctorRegSuccess" component={doctorRegSuccess} />
          <Route
            path="/registrationErrorPage"
            component={registrationErrorPage}
          />

          {/* Protected routes (require authentication) */}
          <ProtectedRoute path="/admin/dashboard" component={AdminDashboard} />
          <ProtectedRoute
            path="/patient/appointmentlist"
            component={Appointmentlist}
          />
          <ProtectedRoute path="/patient/inbox" component={Inbox} />
          <ProtectedRoute path="/patient/send" component={Send} />
          <ProtectedRoute
            path="/patient/messgedetail"
            component={Messgedetail}
          />
          <ProtectedRoute path="/patient/profile" component={Profile} />
          <ProtectedRoute
            path="/patient/profile-edit"
            component={ProfileEdit}
          />
          <ProtectedRoute path="/doctor/dashboard" component={Dashboard} />
          <ProtectedRoute path="/doctor/gallery" component={Drgallery} />
          <ProtectedRoute
            path="/doctor/changepassword"
            component={ChangePassword}
          />
          <ProtectedRoute path="/doctor/worktime" component={WorkTime} />
          <ProtectedRoute
            path="/doctor/doctorprofile"
            component={Doctorprofile}
          />
          <ProtectedRoute path="/doctor/docservices" component={Docservices} />
          <ProtectedRoute
            path="/doctor/videoSchedule"
            component={VideoSchedule}
          />
          <ProtectedRoute
            path="/doctor/healtharticle"
            component={Healtharticle}
          />
          <ProtectedRoute
            path="/doctor/healthblog/:healthInfoId?"
            component={Healthblog}
          />
          <ProtectedRoute
            path="/patient/health-record"
            component={HealthRecord}
          />
          <ProtectedRoute path="/patient/history" component={History} />
          <ProtectedRoute
            path="/doctor/videocall"
            component={DoctorVideocall}
          />
          <ProtectedRoute path="/doctor/doctorinbox" component={DoctorInbox} />
          <ProtectedRoute path="/doctor/doctorsend" component={DoctorSend} />
          <ProtectedRoute
            path="/doctor/messgedetail"
            component={DoctorMessgedetail}
          />
          <ProtectedRoute
            path="/doctor/chatmessage"
            component={DoctorChatmessage}
          />
          <ProtectedRoute
            path="/doctor/chatmessagegroup"
            component={DoctorChatmessageGroup}
          />
          <ProtectedRoute
            path="/doctor/chat-history"
            component={DoctorChatHistory}
          />
          <ProtectedRoute
            path="/patient/prescriptionList"
            component={PrescriptionList}
          />
          <ProtectedRoute
            path="/prescriptionAdd-:hospitalId?-:memberId?-:scheduleId?-:patientName"
            component={PrescriptionAdd}
          />
          <ProtectedRoute path="/dashboard/analysis" component={Analysis} />
          <ProtectedRoute
            path="/doctor/inpersonAppointment"
            component={InpersonAppointment}
          />
          <ProtectedRoute
            path="/doctor/prescriptionList-:hospitalId?-:memberId?-:patientName?-:scheduleId"
            component={DoctorPrescription}
          />
          <ProtectedRoute path="/timeComponent" component={timeComponent} />
          <ProtectedRoute
            path="/doctor/videoRecordList/:appointmentId?"
            component={videoRecordList}
          />
          <ProtectedRoute
            path="/doctor/reportDoctor"
            component={reportDoctor}
          />
          <ProtectedRoute
            path="/dashboard/hospitalReports/:groupHospitalId"
            component={hospitalReports}
          />
          <ProtectedRoute
            path="/dashboard/privilegeCardReport/:groupHospitalId"
            component={privillageReport}
          />
          <ProtectedRoute
            path="/dashboard/reportDashboard/:groupHospitalId"
            component={reportDashboard}
          />
          <ProtectedRoute
            path="/dashboard/videoaudioReports/:groupHospitalId"
            component={videoaudioReports}
          />
          <ProtectedRoute
            path="/dashboard/textChatReports/:groupHospitalId"
            component={textChatReports}
          />
          <ProtectedRoute
            path="/dashboard/inPersonReports/:groupHospitalId"
            component={inPersonReports}
          />
          <ProtectedRoute
            path="/dashboard/patientTransactionReport/:groupHospitalId"
            component={patientTransactionReport}
          />
          <ProtectedRoute path="/themeColor" component={ThemeColor} />
          <ProtectedRoute path="/newFeedsList" component={NewFeeds} />
          <ProtectedRoute
            path="/newFeedsListDetails"
            component={NewFeedsListDetails}
          />
          <ProtectedRoute
            path="/patient/openAppointmentList"
            component={OpenAppointmentlist}
          />
          <ProtectedRoute path="/journalListing" component={JournalListing} />
          <ProtectedRoute
            path="/dashboard/doctorRegistrationReport/:groupHospitalId"
            component={DoctorRegistrationReport}
          />
          <ProtectedRoute
            path="/dashboard/BannerIDASave:bannerId?"
            component={IDABannerSave}
          />
          <ProtectedRoute
            path="/dashboard/BannerIDAListing"
            component={BannerIDAListing}
          />
          <ProtectedRoute
            path="/dashboard/pharmaNetworkReport/:groupHospitalId"
            component={PharmaNetworkReport}
          />
          <ProtectedRoute
            path="/dashboard/doctorNetworkReport/:groupHospitalId"
            component={DoctorNetworkReport}
          />
          <ProtectedRoute
            path="/adminManagement/adApprovalEdit/:pharmaRepAdsId"
            component={AddapprovalEdit}
          />
          <ProtectedRoute
            path="/adminManagement/pharmadashboardList/addEditIdaStore/:storeId?"
            component={AddEditIdaStore}
          />
          <ProtectedRoute
            path="/adminManagement/idaStoresList"
            component={IdaStoreList}
          />
          <ProtectedRoute
            path="/adminManagement/dataMigration/generateQRcodeIda/:storeId?"
            component={GenerateQRcodeIda}
          />
          <ProtectedRoute
            path="/adminManagement/categoriesList"
            component={CategoriesList}
          />
          <ProtectedRoute
            path="/adminManagement/categoriesListEdit/:storeId?"
            component={CategoriesListEdit}
          />
          <ProtectedRoute
            path="/adminManagement/offerAddPage"
            component={offerAddPage}
          />
          <ProtectedRoute
            path="/adminManagement/addEditofferPage/:storeId?/:offerId?"
            component={addEditofferPage}
          />
          <ProtectedRoute
            path="/doctor/addJournal/:journalId?"
            component={AddJournal}
          />
          <ProtectedRoute
            path="/admin/dataMigration"
            component={dataMigration}
          />
          <ProtectedRoute path="/admin/adApproval" component={adApproval} />
          <ProtectedRoute
            path="/analytics/dashboard"
            component={AnalyticsDashboard}
          />
          <ProtectedRoute
            path="/analytics/finalReports"
            component={AnalyticsReport}
          />
          <ProtectedRoute
            path="/adminManagement/journalListing"
            component={JournalListings}
          />
          <ProtectedRoute
            path="/adminManagement/journalListingAdd/:journalId?"
            component={JournalListingsAdd}
          />
          <ProtectedRoute
            path="/adminManagement/create-poll"
            component={CreatePoll}
          />
          <ProtectedRoute
            path="/adminManagement/poll-list"
            component={PollList}
          />
          <ProtectedRoute
            path="/adminManagement/poll-report"
            component={PollReport}
          />
          <ProtectedRoute
            path="/adminManagement/poll-History"
            component={PollHistory}
          />

          {/* Site-specific routes based on siteId */}
          {siteId === "1" ? (
            <Route>
              <Route
                path="/home/doctor-list-main/:serviceType"
                component={DoctorListMain1}
                exact
              />
              <Route path="/Doctor-:slug" component={DoctorDetailIDA} />
              <Route path="/HealthInfo" component={SiteBlogIDA} />
              <Route
                path="/HealthBlog/:blogId?/:shortDescri"
                component={BlogDetailsIDA}
                exact
              />
            </Route>
          ) : (
            <Route>
              <Route
                path="/home/doctor-list-main/:serviceType"
                component={DoctorListMain}
                exact
              />
              <Route path="/Doctor-:slug" component={DoctorDetail} />
              <Route path="/HealthInfo" component={SiteBlog} />
              <Route
                path="/HealthBlog/:blogId?/:shortDescri"
                component={BlogDetails}
                exact
              />
            </Route>
          )}
          {/* Catch all route - redirect to home */}
          <Route path="*" component={() => <Redirect to="/" />} />
        </Switch>
      </Router>
    );
  }
}
